import { useContext } from 'react';
import TraPhaseContext, {
    type TRAPhaseContextValues,
} from '../contexts/TraPhaseContext';

export default function useTRAPhase(): TRAPhaseContextValues {
    const context = useContext(TraPhaseContext);
    if (context === undefined) {
        throw new Error('useTraPhase must be used within a TraPhaseProvider');
    }
    return context;
}
